.note-row {
  align-items: flex-end;

  .note-input {
    flex: 1;

    label {
      font-size: 14px;
      font-weight: 500;
      color: var(--grey-900);
    }
  }
}
